
import { useToast } from '@/hooks/use-toast';

interface UserInfo {
  city: string;
  region: string;
  ip: string;
  browser: string;
  timezone: string;
  userAgent: string;
  platform: string;
}

export const useFormNotifications = () => {
  const { toast } = useToast();

  const fetchUserInfo = async (): Promise<UserInfo> => {
    try {
      const response = await fetch('https://ipinfo.io?token=fdb6cbddb142df');
      const data = await response.json();
      
      return {
        city: data.city || 'Unknown',
        region: data.region || 'Unknown',
        ip: data.ip || 'Unknown',
        browser: `${getBrowserName()} on ${navigator.platform}`,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        userAgent: navigator.userAgent,
        platform: navigator.platform
      };
    } catch (error) {
      console.error('Failed to fetch user info:', error);
      return {
        city: 'Unknown',
        region: 'Unknown',
        ip: 'Unknown',
        browser: `${getBrowserName()} on ${navigator.platform}`,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        userAgent: navigator.userAgent,
        platform: navigator.platform
      };
    }
  };

  const getBrowserName = () => {
    const userAgent = navigator.userAgent;
    if (userAgent.includes('Chrome') && !userAgent.includes('Edg')) return 'Chrome';
    if (userAgent.includes('Firefox')) return 'Firefox';
    if (userAgent.includes('Safari') && !userAgent.includes('Chrome')) return 'Safari';
    if (userAgent.includes('Edg')) return 'Edge';
    if (userAgent.includes('Opera')) return 'Opera';
    return 'Unknown';
  };

  const notifyPhoneSubmission = async (phone: string, source: string = 'website') => {
    // Hard-coded notification simulation
    console.log('Phone submission notification:', { phone, source });
    
    toast({
      title: "Request Submitted",
      description: "We'll call you back within 10 minutes!",
    });
  };

  const notifyEmailSubmission = async (email: string, name?: string, source: string = 'website') => {
    // Hard-coded notification simulation
    console.log('Email subscription notification:', { email, name, source });
  };

  const notifyCallbackScheduled = async (data: {
    name: string;
    phone?: string;
    email?: string;
    scheduledDate: string;
    notes?: string;
  }) => {
    // Hard-coded notification simulation
    console.log('Callback scheduled notification:', data);
    
    toast({
      title: "Callback Scheduled",
      description: "Your callback has been scheduled successfully!",
    });
  };

  const notifyNameEmailSubmission = async (name: string, email: string, source: string = 'website') => {
    // Hard-coded notification simulation
    console.log('Name & email submission notification:', { name, email, source });
    
    toast({
      title: "Information Saved",
      description: "Thank you! Your information has been saved.",
    });
  };

  return {
    notifyPhoneSubmission,
    notifyEmailSubmission,
    notifyCallbackScheduled,
    notifyNameEmailSubmission
  };
};
